export default {
  blends: {
    validationMessage:{
      requiredMessage:'Kolom ini wajib diisi',
      isNumber:'Kolom ini wajib diisi',
      isValidNumber:'Harus berupa angka yang valid',
      noNegativeNumbers:'Nilai tidak boleh negatif',
      atLeastTwoProducts:'Setidaknya dua produk diperlukan',
      
    },
    exemptProducts: {
      eudrExemptProducts: 'Produk yang Dikecualikan EUDR',
      addEUDRExemptProduct: 'Tambah Produk yang Dikecualikan EUDR',
      updateEUDRExemptProduct: 'Perbarui Produk yang Dikecualikan EUDR',
      internalRefNumber: 'Nomor Referensi Internal',
      supplier: 'Pemasok',
      containerID: 'ID Kontainer',
      product: 'Produk',
      quantity: 'Kuantitas',
      dateAdded: 'Tanggal Ditambahkan',
      addProduct: 'Tambah Produk',
      selectDate: 'Pilih Tanggal',
      addContainer: 'Tambah Kontainer',
      containerInformation: 'Informasi Kontainer',
      supplierInformation: 'Informasi Pemasok',
      supplierInformationTT:
        'Detail tentang entitas yang menyediakan barang atau layanan.',
      supplierTooltip: 'Pilih pemasok dari daftar yang terdaftar di sistem.',
      addnewSupplier: 'Tambah Pemasok Baru',
      internalReferenceNumberMustBeAlphanumeric:
        'Nomor referensi internal harus alfanumerik',
      netMassMustBeValid: 'Massa bersih harus valid',
      volumeMustBeNumeric: 'Volume harus numerik',
      subProduct: 'Sub-Produk',
      netMass: 'Massa Bersih',
      volume: 'Volume',
      productDetail: 'Detail Produk',
      placeOfActivity: 'Tempat Aktivitas',
      countryOfActivity: 'Negara Aktivitas',
      countryOfEntry: 'Negara Masuk',
      activity: 'Aktivitas',
      internalRefNo: 'Nomor Referensi Internal',
      name: 'Nama',
      email: 'Email',
      phoneNumber: 'Nomor Telepon',
      country: 'Negara',
      status: 'Status',
      addNewSupplier: 'Tambah Pemasok Baru',
      availableForBlends: 'Tersedia untuk Campuran',
      thisFieldIsRequired: 'Bidang ini wajib diisi.',
      enterSupplierFirstName: 'Masukkan Nama Depan Pemasok',
      enterSupplierLastName: 'Masukkan Nama Belakang Pemasok',
      enterEmailAddress: 'Masukkan Alamat Email',
      enterPhoneNumber: 'Masukkan Nomor Telepon',
      selectCountry: 'Pilih Negara',
      firstNameIsRequired: 'Nama depan wajib diisi',
      lastNameIsRequired: 'Nama belakang wajib diisi',
      unAvailableForBlends: 'Tidak Tersedia untuk Campuran',
      exemptAddedSuccessfully:
        'Produk yang dikecualikan EUDR telah berhasil ditambahkan!',
      unExpectedErrorMsg:
        'Terjadi kesalahan yang tidak terduga. Silakan coba lagi.',
      availabilityStatusMsg:
        'Status ketersediaan untuk campuran telah berhasil diperbarui.',
      updateProduct: 'Perbarui Produk',
      exemptUpdatedSuccessfully:
        'Produk yang dikecualikan EUDR telah berhasil diperbarui!',
      invalidNumericValue: 'Nilai numerik tidak valid',
      containerIDTT:
        'Ini adalah ID unik untuk Kontainer. Silakan masukkan ID Kontainer di bawah',
        actions: 'Tindakan',
    },
  
    blends: 'Campuran',
    blendSetting: 'Pengaturan Campuran',
    createBlendDds: 'Buat Campuran Dds',
    country: 'Negara',
    countryTT: 'Negara',
    select: 'Pilih',
    edurDueDeligenceStatus: 'Status Uji Tuntas EUDR',
    dueDiligenceStatus: 'Status Uji Tuntas',
    EUDRDeforestationStatusTT: 'Status Deforestasi EUDR',
    dueDeligenceStatus: 'Status Uji Tuntas',
    uploadedToEU: 'Diunggah ke EU',
    pending: 'Menunggu',
    underReview: 'Sedang Ditinjau',
    compliant: 'Patuh',
    nonCompliant: 'Tidak Patuh',
    processingFarm: 'Memproses Pertanian',
    analyzingDeforestation: 'Menganalisis Deforestasi',
    writingToBlockchain: 'Menulis ke Blockchain',
    readyToProceed: 'Siap Dilanjutkan',
    mitigationRequired: 'Mitigasi Diperlukan',
    viewReport: 'Lihat Laporan',
    share: 'Bagikan',
    copyAndCreateNew: 'Salin dan Buat Baru',
    remove: 'Hapus',
    eudrRefNo: 'No. Referensi EUDR/Internal',
    finalProduct: 'Nama Produk Akhir & ID Lot Campuran',
    noOfIngredients: 'Jumlah Bahan',
    farmsAndQuantity: 'Pertanian & Kuantitas',
    actions: 'Tindakan',
    confirmDialog: {
      delete: {
        title: 'Hapus Campuran',
        message: 'Apakah Anda yakin ingin menghapus Campuran ini?',
        confirmBtn: 'Konfirmasi',
        cancelBtn: 'Batal',
      },
    },
    searchBlend: 'Cari Campuran berdasarkan Produk Akhir',
    blendDuplicatedSuccessfully: 'Campuran berhasil digandakan.',
    reportDeletedSuccessfully: 'Laporan berhasil dihapus.',
  
    blendSettings: {
      dashboard: 'Dasbor',
      blendSettings: 'Pengaturan Campuran',
      importBlends: 'Impor Campuran',
      addNewBlend: 'Tambahkan Campuran Baru',
      searchTitle: 'Cari berdasarkan Judul Campuran',
      view: 'Lihat',
      edit: 'Edit',
      remove: 'Hapus',
      farms: 'Peternakan',
      blendCode: 'Kode Campuran',
      blendTitle: 'Judul Campuran',
      description: 'Deskripsi',
      'finalProductName&Code': 'Nama & Kode Produk Akhir',
      dateAdded: 'Tanggal Ditambahkan',
      actions: 'Tindakan',
      addBlend: 'Tambahkan Pengaturan Campuran',
      cancel: 'Batal',
      createBlend: 'Buat Campuran',
      generalData: 'Data Umum',
      generalDataTT: "Label ini menunjukkan semua data di layar.",
      blendTitleTT: "Dropdown dapat diakses dengan mengkliknya, yang akan menampilkan daftar campuran yang tersedia untuk dipilih.",
      enterHere: 'Masukkan di sini',
      blendCodeTT: 'Kode Campuran',
      blendDescription: 'Deskripsi Campuran',
      blendDescriptionTT: 'Deskripsi Campuran',
      finalProductName: 'Nama Produk Akhir',
      finalProductNameTT: 'Nama Produk Akhir',
      finalProductCode: 'Kode Produk Akhir',
      finalProductCodeTT: 'Kode Produk Akhir',
      processType: 'Jenis Proses',
      processTypeTT: 'Jenis Proses',
      finalProductLotIdGen: 'Generator Lot ID Produk Akhir Campuran',
      finalProductLotIdGenTT: 'Generator Lot ID Produk Akhir Campuran',
      productDetails: 'Produk Campuran (Bahan)',
      productDetailsTT: 'Produk Campuran (Bahan)',
      selectType: 'Pilih Jenis',
      startCount: 'Hitungan Awal',
      resetCounterEach: 'Setel Ulang Penghitung Setiap',
      enter: 'Masukkan',
      staticText: 'Teks Statis',
      incrementalNumber: 'Nomor Bertambah',
      year: 'Tahun',
      month: 'Bulan',
      date: 'Tanggal',
      none: 'Tidak Ada',
      space: 'Spasi',
      '0001': '0001',
      resetCounter: 'Setel ulang penghitung setiap',
      selectSeparator: 'Pilih Pemisah',
      previewLotId: 'Pratinjau ID Lot',
      blendProducts: 'Produk Campuran',
      blendProductsTT: 'Produk Campuran',
      product: 'Produk',
      productTT: 'Produk',
      selectProduct: 'Pilih Produk',
      subProduct: 'Subproduk',
      subProductTT: 'Subproduk',
      selectSubProduct: 'Pilih Subproduk',
      originCountry: 'Negara Asal',
      originCountryTT: 'Negara Asal',
      selectCountry: 'Pilih Negara',
      percentage: 'Persentase',
      percentageTT: 'Persentase',
      addAnotherProduct: 'Tambahkan Produk Lain',
      confirmation: 'Konfirmasi',
      createBlendMessage: 'Apakah Anda yakin ingin menambahkan campuran baru?',
      updateBlendMessage: 'Apakah Anda yakin ingin memperbarui campuran ini?',
      confirm: 'Konfirmasi',
      pleaseFillRequiredFields: 'Harap isi kolom yang wajib diisi',
      lightRoast: 'Sangrai Ringan',
      mediumRoast: 'Sangrai Sedang',
      mediumDarkRoast: 'Sangrai Sedang-Gelap',
      darkRoast: 'Sangrai Gelap',
      validation: {
        titleRequired: 'Judul wajib diisi',
        codeRequired: 'Kode campuran wajib diisi',
        descriptionRequired: 'Deskripsi wajib diisi',
        finalProductNameRequired: 'Nama produk akhir wajib diisi',
        finalProductCodeRequired: 'Kode produk akhir wajib diisi',
        processTypeRequired: 'Jenis proses wajib diisi',
        selectTypeRequired: 'Jenis wajib diisi',
        startCountRequired: 'Hitungan awal wajib diisi',
        selectSeparatorRequired: 'Pemisah wajib diisi',
        finalProductLotIdGenRequired: 'Pembuatan ID lot produk akhir wajib diisi',
        productRequired: 'Produk wajib diisi',
        subProductRequired: 'Subproduk wajib diisi',
        originCountryRequired: 'Negara asal wajib diisi',
        percentageRequired: 'Persentase wajib diisi',
        hundredPrecent: 'Persentase total harus tepat 100%',
        productSubproductDuplicatedMsg: 'Produk dan subproduk duplikat',
      },
      mustSelectIncrementalNumber:
        'Setidaknya satu nomor bertambah harus dipilih',
      blendSettingsCreated: 'Pengaturan campuran berhasil dibuat.',
      blendSettingsNotCreated:
        'Pembuatan pengaturan campuran gagal. Coba lagi dengan data yang benar.',
      confirmDiaglog: {
        delete: {
          title: 'Hapus',
          message: 'Apakah Anda yakin ingin menghapus pengaturan campuran ini?',
          confirmBtn: 'Konfirmasi',
          cancelBtn: 'Batal',
        },
      },
      itemDeletedSuccessfully: 'Pengaturan campuran berhasil dihapus',
      updateBlend: 'Perbarui Pengaturan Campuran',
      save: 'Simpan',
      blendSettingsUpdated: 'Pengaturan campuran berhasil diperbarui.',
      blendSettingsNotUpdated:
        'Pembaruan pengaturan campuran gagal. Coba lagi dengan data yang benar.',
      updateMessage: 'Apakah Anda yakin ingin memperbarui campuran ini?',
      createMessage: 'Apakah Anda yakin ingin menambahkan campuran baru?',
      finalProductCodeAlreadyExists: 'Kode produk akhir sudah ada',
      blendCodeAlreadyExists: 'Kode campuran sudah ada.',
      valueMustBeNumber: 'Bidang ini harus berupa angka',
      valueMustBeNonNegative: 'Bidang ini harus lebih besar dari nol',
    },
  
    imports: {
      imports: 'Impor',
      blends: 'Campuran',
      createNewImport: 'Buat Impor Baru',
      importsBlends: 'Impor Campuran',
      createBlends: 'Buat Campuran',
      downloadTemplateInfo:
        'Unduh dan gunakan template di bawah ini untuk impor geofences secara massal.',
      selectTemplate: 'Pilih Template',
      downloadXlsTemplate: 'Unduh Format Template Impor XLS',
      downloadProductCodes: 'Unduh Kode Produk',
      selectFileToUpload: 'Pilih file untuk mengunggah data',
      orDragDrop: 'Atau seret dan jatuhkan file di sini',
      removeFile: 'Hapus File',
      importantNote: 'Catatan Penting',
      templateNote:
        'Harap gunakan template yang disediakan di atas untuk unggahan massal. Format lain akan menyebabkan kegagalan.',
      importData:'Pastikan data ini tidak akan disimpan sampai semua status berhasil',
      fileUploadSuccess: 'File berhasil diunggah',
      invalidFileFormat: 'Format file tidak valid. Harap unggah file yang valid',
      pleaseSelectSource: 'Harap pilih setidaknya satu sumber',
      blendTitle: 'Judul Campuran',
      blendCode: 'Kode Campuran',
      finalProductCode: 'Kode Produk Akhir',
      finalProductName: 'Nama Produk Akhir',
      status: 'Status',
      downloadCsvTemplate: 'Unduh Format Template Impor CSV',
      dropHere: 'atau seret dan jatuhkan di sini',
      Importing: 'Mengimpor...',
      modalMessage:
        'File yang Anda unggah sedang diproses. Kami akan memberi tahu Anda setelah file berhasil diunggah.',
      importXLSFormat: 'Impor Format XLS',
      importCSVFormat: 'Impor Format CSV',
      fileSelected: 'File telah berhasil dipilih.',
      success: 'Data berhasil diimpor.',
      importCompleted: 'Impor Selesai',
      invalidHeaders: "Header File Tidak Valid",
      headerMismatchErro: "File yang diunggah harus berisi header berikut",
      missingHeaders: "Header yang Hilang",
      additionalHeaders: "Header Tambahan (tidak diperbolehkan)"
    },
    history: {
      history: 'Riwayat',
      fileName: 'Nama File',
      importedOn: 'Diimpor Pada',
      status: 'Status',
      action: 'Tindakan',
      blends: 'Campuran',
      download: 'Unduh',
      success: 'Sukses',
      failed: 'Gagal'
    },
    createBlends: {
      eudrDueDiligence: 'Uji Tuntas EUDR',
      createBlends: 'Buat Campuran',
      discard: 'Buang',
      reject: 'Tolak',
      saveAndContinueLater: 'Simpan dan Lanjutkan Nanti',
      generateReport: 'Hasilkan Laporan',
      generalData: 'Data Umum',
      blend: 'Campuran',
      selectBlend: 'Pilih Campuran',
      blendCode: 'Kode Campuran',
      blendDescription: 'Deskripsi Campuran',
      finalProduct: 'Produk Akhir',
      finalProductCode: 'Kode Produk Akhir',
      netMass: 'Massa Bersih',
      netMassTT: "Memungkinkan pengguna untuk memasukkan nilai pajak massa bersih yang terkait dengan produk, pengiriman, atau transaksi.",
      volume: 'Volume',
      volumeTT: "Label ditampilkan secara mencolok di sebelah bidang atau bagian tempat data terkait volume disajikan atau dimasukkan, seperti dalam spesifikasi produk atau formulir pengiriman.",
      blendLotId: 'ID Lot Campuran',
      blendLotIdTT: "Menampilkan pengenal lot unik sesuai dengan konfigurasi pengaturan Blend untuk melacak batch campuran.",
      finishedProductLotId: 'ID Lot Produk Jadi',
      finishedProductLotIdTT: "Masukkan pengenal lot unik untuk melacak batch produk akhir.",
      enterHere: 'Masukkan di Sini',
      internalReferenceNumber: 'Nomor Referensi Internal',
      internalReferenceNumberTT: "Kode referensi internal untuk keperluan pelacakan.",
      eudrReferenceNumber: 'Nomor Referensi EUDR',
      eudrReferenceNumberTT: "Kode referensi kepatuhan EUDR (Peraturan Deforestasi Uni Eropa). Ini akan diisi secara otomatis jika pengguna ingin mengunggah ke EUDR setelah pembuatan laporan.",
      companyId: 'ID Perusahaan',
      companyIdTT: "Pengenal untuk perusahaan yang terkait dengan campuran ini.",
      activity: 'Kegiatan',
      domestic: 'Domestik',
      import: 'Impor',
      export: 'Ekspor',
      containerInformation: 'Informasi Kontainer',
      containerInformationTT: "Ini adalah pengenal unik untuk Kontainer. Silakan masukkan ID Kontainer di bawah ini.",
      addContainer: 'Tambah Kontainer',
      blendProduct: 'Produk Campuran',
      blendProductTT: "Tambahkan beberapa Produk dan Sub Produk dari Produk Bebas DDS/EUDR untuk membuat Campuran.",
      product: 'Produk',
      productTT: "Menunjukkan kepada pengguna produk yang dipilih dari daftar produk yang tersedia di Pengaturan Campuran untuk pemrosesan, analisis, atau pelaporan dalam aplikasi, memfasilitasi entri data dan manajemen yang akurat.",
      subProduct: 'Subproduk',
      subProductTT: "Menunjukkan kepada pengguna sub-produk yang dipilih dari sub-produk yang tersedia di Pengaturan Campuran terkait dengan produk utama yang dipilih, memfasilitasi entri data dan manajemen yang terperinci dalam aplikasi.",
      ddsId: 'ID DDS',
      containerId: 'ID Kontainer',
      uniqueContainerId:"ID Kontainer harus unik",
      containerIdTT: "Pengenal unik untuk kontainer yang membawa campuran ini.",
      country: 'Negara',
      countryTT: "Pilih negara yang terkait dengan asal atau tujuan campuran.",
      search: 'Cari',
      select: 'Pilih',
      addAnotherProduct: 'Tambah Produk Lain',
      customization: 'Kustomisasi',
      recordsPerPage: 'Catatan per Halaman',
      restoreDefault: 'Kembalikan ke Default',
      apply: 'Terapkan',
      applyFilter:"Terapkan Filter",
      clearFilter:"Hapus Filter",
      status: {
        compliant: 'Sesuai',
        nonCompliant: 'Tidak Sesuai',
        uploadToEudr:"DIUNDUH KE PORTAL UE",
        eudrExempt: "BEBAS EUDR",
      },
      table: {
        eudrInternalRef: 'EUDR / No. Referensi Internal',
        containerId: 'ID Kontainer',
        product: 'Produk',
        farmsQuantity: 'Pertanian & Kuantitas',
        submissionDate: 'Tanggal Pengajuan',
        dueDiligenceStatus: 'Status Uji Tuntas',
        availabilityForBlends: 'Ketersediaan untuk Campuran',
        pleaseSelectSource: 'Silakan pilih setidaknya satu sumber',
      },
      productionPlaceTable: {
        productionPlaceAndFarmId: 'Tempat Produksi & ID Pertanian',
        product: 'Produk',
        producerName: 'Nama Produsen',
        addressOfProduction: 'Alamat Produksi',
        status: 'Status Deforestasi EUDR',
        riskAssessment: 'Penilaian Risiko',
      },
      
      addNewSupplier: 'Tambah Pemasok Baru',
      addNewBlend: 'Tambah Campuran Baru',
      placeOfActivity: 'Tempat Aktivitas Operator',
      placeOfActivityTT: "Tentukan negara operator tempat aktivitas dilakukan dan negara tempat produk memasuki pasar UE. Detail ini sangat penting untuk memastikan kepatuhan terhadap persyaratan EUDR.",
      countryOfActivity: 'Negara Aktivitas Operator',      
      countryOfActivityTT: "Pilih negara tempat aktivitas ini berlangsung.",
      countryOfEntry: 'Negara Masuk',
      countryOfEntryTT: "Pilih negara titik masuk untuk produk impor.",
      pleaseSelectAtLeastOne: 'Silakan pilih setidaknya satu laporan dari setiap produk',
      blendCreatedSuccessfully: "Blend telah berhasil dibuat.",
      blendCreateFailed: "Terjadi kesalahan saat membuat blend.",
      blendUpdatedSuccessfully: "Blend telah berhasil diperbarui.",
      blendUpdateFailed: "Terjadi kesalahan saat memperbarui blend.",
      blendDeletedSuccessfully: "Blend telah berhasil dihapus.",
      blendSavedSuccessfully: 'Blend telah berhasil disimpan.',
      blendUploadedToEUSuccessfully: "Blend telah berhasil diunggah ke EU.",
    },
    manageProducts: {
      addNewProduct: 'Tambahkan Produk Baru',
      editProduct: 'Edit Produk',
      addNewSubProduct: 'Tambahkan Subproduk Baru',
      editSubProduct: 'Edit Subproduk',
      productTitle: 'Judul Produk',
      subProductTitle: 'Judul Subproduk',
      typeTitle: 'Ketik Judul',
      hsCode: 'Kode HS',
      typeHSCode: 'Ketik Kode HS',
      eudrDocumentCode: 'Kode Dokumen EUDR',
      selectEudrDocumentCode: 'Pilih Kode Dokumen EUDR',
      makeSelection: 'Buat Pilihan',
      uploadCategoryImage: 'Unggah Gambar Kategori',
      addImage: 'Tambahkan Gambar',
      cancel: 'Batal',
      save: 'Simpan',
      back: 'Kembali',
      add: 'Tambahkan',
      confirm: 'Konfirmasi',
      deleteMessage: 'Apakah Anda yakin ingin menghapus',
      invalidFileType: 'Jenis File Tidak Valid',
      errorUploadingFile:
        'Terjadi kesalahan tak terduga saat mengunggah file. Silakan coba lagi nanti.',
      fileUploadFailed: 'Gagal Mengunggah File',
      selectDocumentCode: 'Pilih Kode Dokumen',
      view: 'Lihat',
      edit: 'Edit',
      remove: 'Hapus',
      search: 'Cari',
      searchByProductName: 'Cari Berdasarkan Nama Produk',
      eudrDueDiligence: 'Uji Tuntas EUDR',
      products: 'Produk',
      subProducts: 'Subproduk',
      fieldRequired: 'Bidang ini wajib diisi',
      fileRequired: 'File Diperlukan',
      fileRequiredMessage:
        'Harap unggah atau pilih file sebelum menyimpan produk.',
      addNewDocumentCode: 'Tambahkan Kode Dokumen Baru',
      enterHere: 'Masukkan di sini',
      documentCode: 'Kode Dokumen',
      title: 'Judul',
      description: 'Deskripsi',
      updateProduct: 'Perbarui Produk',
      updateSubProduct: 'Perbarui Subproduk',
      deleteSubProduct: 'Hapus Subproduk',
      deleteProduct: 'Hapus Produk',
      productAddedMessage: 'Produk berhasil ditambahkan.',
      subProductAddedMessage: 'Subproduk berhasil ditambahkan.',
      productUpdateMessage: 'Produk berhasil diperbarui.',
      subProductUpdateMessage: 'Subproduk berhasil diperbarui.',
      subProductDeleteMessage: 'Subproduk berhasil dihapus.',
      productDeleteMessage: 'Produk berhasil dihapus.',
      pleaseTryAgain: 'Terjadi kesalahan. Silakan coba lagi nanti.',
      documentCodeDuplicate: 'Kode dokumen sudah ada',
      unsupportedFileFormat: 'Jenis file tidak didukung. Silakan unggah file gambar yang valid',
      tableHeaders: {
        productName: 'Nama Produk',
        hsCode: 'Kode HS',
        eudrDocumentCode: 'Kode Dokumen EUDR',
        subProduct: 'Subproduk',
        dateAdded: 'Tanggal Ditambahkan',
        action: 'Tindakan',
      },
      documentCodeSaved: 'Kode Dokumen berhasil disimpan.',
    },
    finalReport: {
      title: 'Laporan Akhir Campuran',
      reportStatus: 'Status Laporan',
      blendTitle: 'Judul Campuran',
      blendCode: 'Kode Campuran',
      finalProduct: 'Produk Akhir',
      finalProductCode: 'Kode Produk Akhir',
      blendDescription: 'Deskripsi Campuran',
      processType: 'Jenis Proses',
      netMass: 'Massa Bersih',
      volume: 'Volume',
      blendLotId: 'ID Lot Campuran',
      finalProductLotId: 'ID Lot Produk Akhir',
      internalReferenceNumber: 'Nomor Referensi Internal',
      eudrReferenceNumber: 'Nomor Referensi EUDR',
      activity: 'Kegiatan',
      countryOfActivity: 'Negara Kegiatan',
      countryOfEntry: 'Negara Masuk',
      dueDiligenceReportStatus: 'Status Laporan Uji Tuntas',
      containerId: 'ID Kontainer',
      operatorData: 'Data Operator',
      name: 'Nama',
      country: 'Negara',
      isoCode: 'Kode ISO',
      eoriNumber: 'Nomor EORI',
      reportSummary: {
        title: 'Ringkasan Laporan',
        totalDdsReports: 'Jumlah Total Laporan DDS',
        totalGeofencePolygons: 'Jumlah Total Poligon Geofence',
        totalGeofencePoints: 'Jumlah Total Titik Geofence',
        totalDeforestationAssessments: 'Jumlah Total Penilaian Deforestasi',
        totalRiskAssessments: 'Jumlah Total Penilaian Risiko',
        totalFarms: 'Jumlah Total Pertanian',
        totalHighDeforestationFarms: 'Jumlah Pertanian dengan Deforestasi Tinggi',
        totalLowZeroRiskFarms: 'Jumlah Pertanian dengan Risiko Rendah atau Nol',
        totalArea: 'Total Luas (ha)',
        averageGeofenceArea: 'Rata-rata Luas Geofence (ha)',
        totalHighRiskFarmArea: 'Luas Total Pertanian Risiko Tinggi',
        totalLowZeroRiskFarmArea: 'Luas Total Pertanian Risiko Rendah atau Nol',
        productionPlaces: 'Tempat Produksi',
        productionPlacesTooltip: 'Detail tentang lokasi produksi',
        declarationStatement: 'Pernyataan oleh Operator',
        declarationStatementTooltip: 'Pernyataan resmi oleh operator',
        declarationText1:
          '[Nama] {name}, dengan ini menyatakan bahwa semua data yang disampaikan dengan pengiriman ini akurat sesuai dengan pengetahuan dan keyakinan saya.',
        declarationText2:
          'Saya, [Nama] {name}, menegaskan bahwa saya telah mengunjungi pertanian yang terkait dengan pengiriman ini dan mengonfirmasi kepatuhan mereka terhadap hukum dan peraturan lokal terkait deforestasi.',
      },
      blendProducts: {
        title: 'Produk Campuran',
        product: 'Produk',
        subProduct: 'Subproduk',
        country: 'Negara',
        reference: 'EUDR / No. Referensi Internal',
        containerId: 'ID Kontainer',
        farmsQuantity: 'Pertanian & Kuantitas',
        submissionDate: 'Tanggal Pengajuan',
        status: 'Status',
      },
      activityLog: {
        title: 'Log Aktivitas',
        user: 'Pengguna',
        userRole: 'Peran Pengguna',
        ipAddress: 'Alamat IP',
        dateTime: 'Tanggal & Waktu',
        segment: 'Segmen',
        activityDescription: 'Deskripsi Aktivitas',
      },
      declaration: {
        title: 'Pernyataan oleh Operator',
        name: 'Nama',
        address: 'Alamat',
        dateTime: 'Tanggal & Waktu',
      },
      buttons: {
        discard: 'Buang',
        reject: 'Tolak',
        edit: 'Edit',
        finalize: 'Finalisasi',
        download: 'Unduh',
        uploadToEuPortal: 'Unggah ke Portal EU',
        submit: 'Kirim',
      },
    },
  }
};